<template>
  <div class="select-teacher bg-white">
    <div class="title">选择开通服务后最想关注的老师</div>
    <div class="icons">
      <div
        class="icon"
        v-for="(item,$index) in teacherList"
        :key="item.enterprise_userid"
        @click="selectTeacher(item, $index)"
        :class="{'active':item.active,'unactive':!item.active}"
      >
        <div class="icon-img">
          <img :src="item.icon_url" alt />
        </div>
        <div class="icon-name small" v-if="item.name.length>5">{{item.name}}</div>
        <div class="icon-name" v-if="item.name.length<=5">{{item.name}}</div>
        <div class="icon-selected" v-show="item.active">
          <img src="/static/img/selected.png" alt />
        </div>
      </div>
    </div>
    <div class="select-teacher-btn" @click="selectComplete">确定</div>
  </div>
</template>

<script>
import Vue from "vue";
import { MessageBox } from "mint-ui";
import { mapGetters } from "vuex";

export default {
  name: "OrderSelectTeacher",
  data: () => ({
    loaded: false,
    completed: false,
    active: false,
    teacherList: [],
    selectedTeacher: ""
  }),
  computed: {
    ...mapGetters({
      order: "getOrder"
    })
  },
  created() {
    this.getTeacherList();
  },
  mounted: function() {
    this.setPageTitle("服务开通");
    document.querySelector(".select-teacher").style.height =
      window.screen.availHeight + "px";
  },
  methods: {
    getTeacherList() {
      let url = "/api/teacher/select-list";
      this.$http.get(url).then(
        response => {
          var rs = response.body;
          if (rs.code === 0) {
            this.teacherList = rs.data.teacher_list;
            console.log(this.teacherList);
          } else {
            this.handleHttpError(response, true);
          }
          this.completed = true;
          this.loaded = true;
        },
        response => {}
      );
    },
    selectTeacher(item, index) {
      this.$nextTick(function() {
        this.teacherList.forEach(function(item) {
          Vue.set(item, "active", false);
        });
        Vue.set(item, "active", true);
      });
      this.selectedTeacher = this.teacherList[index].enterprise_userid;
    },
    selectComplete() {
      let orderNo = this.$route.params.id;
      if (this.selectedTeacher === "") {
        MessageBox.alert("请选择想要关注的老师~");
      } else {
        this.loading("正在开通服务...");
        let url =
          "/api/teacher/" + this.selectedTeacher + "?orderNo=" + orderNo;
        this.$http.post(url).then(
          response => {
            this.loadingHide();
            var rs = response.body;
            if (rs.code === 0) {
              this.$router.push("/orders/service/complete/" + orderNo);
            } else {
              MessageBox.alert(rs.message);
            }
          },
          response => {
            this.loadingHide();
          }
        );
      }
    }
  }
};
</script>

<style scoped>
.select-teacher {
  font-size: 18px;
  color: #333;
  text-align: center;
  overflow: hidden;
}
.select-teacher .title {
  margin-top: 20px;
  height: 25px;
  line-height: 25px;
}
.select-teacher .icons {
  padding: 16px 12px;
  overflow: hidden;
}
.select-teacher .icon {
  position: relative;
  float: left;
  width: 78px;
  height: 96px;
  font-size: 14px;
  background: #fff;
  padding: 10px 0;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #e2e2e2;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
.select-teacher .icon.active {
  border: 1px solid rgba(67, 153, 255, 0.5);
  box-shadow: 0 0 5px rgba(25, 115, 221, 0.38);
}
.select-teacher .icon-img {
  height: 56px;
}
.select-teacher .icon-img img {
  width: 56px;
  height: 56px;
  border-radius: 50%;
}
.select-teacher .icon-name {
  height: 20px;
  line-height: 20px;
  margin-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.select-teacher .icon-name.small {
  font-size: 12px;
}
.select-teacher .icon-selected {
  position: absolute;
  top: 8px;
  right: 8px;
}
.select-teacher .icon-selected img {
  width: 22px;
}
.select-teacher .select-teacher-btn {
  position: fixed;
  bottom: 40px;
  left: calc(50% - 130px);
  font-size: 19px;
  font-weight: bold;
  width: 260px;
  height: 48px;
  line-height: 48px;
  color: #fff;
  background: #4399ff;
  border-radius: 5px;
  box-shadow: 0 0 5px #4399ff;
}
.select-teacher .select-teacher-btn:active {
  background: #078ef2;
}
@media (min-width: 374px) and (max-width: 376px) {
  .select-teacher .icon:nth-child(4n) {
    margin-right: 0;
  }
}

@media (min-width: 359px) and (max-width: 373px) {
  .select-teacher .icon {
    margin-right: 8px;
  }
  .select-teacher .icon:nth-child(4n) {
    margin-right: 0;
  }
}

@media screen and (max-width: 358px) {
  .select-teacher .icon {
    margin-right: 30px;
  }
  .select-teacher .icon:nth-child(3n) {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// OrderSelectTeacher.vue?1899eb2a